import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"height":"auto"} }
const _hoisted_2 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_8 = { style: {"margin":"0 10px"} }

import { Member } from "@/model/member";
import { ref, onMounted, h } from "vue";
import { getCallable } from "@/config/env";
import {
  NSpace,
  NCard,
  NDataTable,
  NButton,
  NModal,
  NDescriptions,
  NDescriptionsItem,
  NForm,
  NFormItem,
  NInput,
  NInputGroup,
  FormInst,
  FormRules,
  NIcon,
  NSelect,
  NSpin,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import * as common from "@/assets/common/common";
import { useAuth } from "@/composables/useAuth";
import { USER_ROUTES } from "@/assets/route_constants";
import { usePagination } from "@/composables/usePagination"; // usePagination 임포트


export default /*@__PURE__*/_defineComponent({
  __name: 'Personal',
  setup(__props) {

const { loading, isLoggedIn } = useAuth();

const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const router = useRouter();
const getUsersCallable = getCallable("getMembers");

const searchValue = ref<string | null>(null);
const searchType = ref("name");

const searchOptions = [
  { label: "사용자명", value: "name" },
  { label: "이메일", value: "email" },
];

const {
  paginatedItems: users,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshUsers,
} = usePagination<Member>(async (params) => getUsersCallable(params), 10);

async function wrappedRefreshUsers() {
  loading.value = true;
  const params: { searchKey?: string; searchValue?: string } = {};

  if (searchValue.value && searchValue.value.trim() !== "") {
    params.searchKey = searchType.value;
    params.searchValue = searchValue.value.trim();
  }
  await composableRefreshUsers(params);
  loading.value = false;
}

const selectedMember = ref<Member | null>(null);
const componentKey = ref(0);
const isCheckingId = ref<boolean>(false);

const idCheckMessage = ref<string>("");
const isIdAvailable = ref<boolean | null>(null);

const columns = [
  {
    title: "ID",
    key: "SK",
    resizable: true,
    render(row: Member) {
      if (row.SK && row.SK.includes("#")) {
        return row.SK.split("#")[1];
      }
      return row.SK;
    },
  },
  {
    title: "사용자명",
    key: "name",
    resizable: true,
  },
  // {
  //   title: "회원등급",
  //   key: null,
  //   resizable: true,
  // },
  // {
  //   title: "성별",
  //   key: null,
  //   resizable: true,
  // },
  // {
  //   title: "지역",
  //   key: null,
  //   resizable: true,
  // },
  {
    title: "이메일",
    key: "email",
    resizable: true,
  },
  {
    title: "등록일",
    key: "createdDate",
    resizable: true,
    render(row: Member) {
      return common.getYYYYMMDD2(Number(row.createdDate));
    },
  },
];

async function wrappedGoToNextPage() {
  if (!hasNextPage.value) return;
  await composableGoToNextPage();
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value <= 1) return;
  await composableGoToPreviousPage();
}

onMounted(() => {
  wrappedRefreshUsers(); // 초기 데이터 로드
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "main_div",
    key: componentKey.value
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NSpace), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("div", { style: {"font-size":"20px","width":"150px","font-weight":"bold"} }, "사용자 관리", -1)
                ])),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _createVNode(_unref(NSpace), {
                vertical: "",
                style: {"margin-top":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), {
                    align: "baseline",
                    "item-style": "display: flex;"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NFormItem), {
                        label: "검색",
                        style: {"min-width":"350px"},
                        "label-placement": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NInputGroup), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NSelect), {
                                value: searchType.value,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchType).value = $event)),
                                options: searchOptions,
                                style: {"width":"120px"}
                              }, null, 8, ["value"]),
                              _createVNode(_unref(NInput), {
                                value: searchValue.value,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
                                placeholder: "검색어를 입력하세요",
                                clearable: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), {
                        style: {"min-width":"300px"},
                        "label-placement": "left"
                      }),
                      _createVNode(_unref(NFormItem), { style: {"margin-bottom":"0"} }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NButton), {
                            type: "primary",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (wrappedRefreshUsers()))
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" 조회 ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(Loading, null, null, 512), [
                [_vShow, _unref(loading)]
              ]),
              _createElementVNode("div", null, [
                (_unref(listLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, "사용자 목록을 불러오는 중..."))
                  : _createCommentVNode("", true),
                (_unref(error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(error)), 1))
                  : _createCommentVNode("", true),
                (!_unref(listLoading) && !_unref(error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_unref(users).length > 0)
                          ? (_openBlock(), _createBlock(_unref(NDataTable), {
                              key: 0,
                              columns: columns,
                              data: _unref(users),
                              pagination: false,
                              bordered: true
                            }, null, 8, ["data"]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_6, "등록된 사용자가 없습니다."))
                      ]),
                      (_unref(users).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToPreviousPage,
                              disabled: _unref(currentPage) === 1,
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                _createTextVNode(" 이전 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"]),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToNextPage,
                              disabled: !_unref(hasNextPage)
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode(" 다음 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})